import type { DataNode } from 'ant-design-vue/es/tree'
import { mergeTreeData } from '@/utils'
export const useTreeDataMemory = (treeDataRef: Ref<DataNode[]>) => {
  const treeDataHistory: DataNode[] = []
  watch(
    treeDataRef,
    (val) => {
      if (!val.length) return
      mergeTreeData(treeDataHistory, val)
      // treeDataHistory.push(...val)
    },
    {
      immediate: true,
    }
  )
  return {
    treeDataHistory,
  }
}
